export const LOOKUNITY = "Look matches from the Unity League";
export const LOOKMATCHES = "Look matches from the ";
export const LOOKPROFILE = "Look the profile of: ";
export const FILTERBY = "Filter matches by tournament: ";
export const WINRATE = "Last 50 matches";
